import StatisticCreateModalController from "./create-modal";
import editorModalTemplate from "../views/create-statistic.tpl.html";

export default class AlGuestlistDashboardNumberStatisticController {

    constructor($scope, $injector, $element) {
        this.scope = $scope;
        this.injector = $injector;
        this.element = $element;

        this.api = this.injector.get('$http');
        this.uibModal = this.injector.get('$uibModal');
        this.navService = this.injector.get('NavService');
        this.acl = this.injector.get('Acl');
        this.alert = this.injector.get('Alert');
        this.refresh = null;
        this.guestlist = null
        this.statistic = null;
        this.data = 0;

    }

    $onInit() {
        this.api.get("stats/statistics/" + this.statistic.id).then(({data}) => {
            this.data = data.result;
        })
            .catch((e) => e);
    }

    delete() {
        this.api.delete("stats/statistics/" + this.statistic.id)
            .then(({data}) => {
                this.refresh();
            })
            .catch((e) => e);
    }

    openEditStatisticModal() {
        this
            ._openEditorModal(StatisticCreateModalController, {
                refresh: this.refresh,
                statistic: this.statistic,
                guestlist: this.guestlist,
            })
            .then(() => {
            });
    }

    _openEditorModal(controller, extendedInformation) {
        extendedInformation = extendedInformation || {};

        return this.uibModal.open({
            controller,
            controllerAs: 'vm',
            templateUrl: editorModalTemplate,
            resolve: {
                extendedInformation: () => extendedInformation
            }
        }).result;
    }
}

AlGuestlistDashboardNumberStatisticController.$inject = [
    '$scope',
    '$injector',
    '$element',
];



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-guestlist-dashboard/controllers/statisticNumber.js